import { DataQueryKey, UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import { GetFindProductGridKeyParams, IProductGridKey } from './product-grid.types';

export const getFindProductGridRootKey = (): UseDataQueryKey => [DataQueryKey.PRODUCT_GRID];

export const getFindProductGridKey = (params: GetFindProductGridKeyParams): UseDataQueryKey => [
  ...getFindProductGridRootKey(),
  params.productColorId,
  {
    availability: params.availability,
    deliveryWindowId: params.deliveryWindowId ?? '',
    orderId: params.orderId ?? '',
    isOfflineMode: params.isOfflineMode || false,
    kitId: params.kitId ?? '',
  },
];

export const getProductGridKey = (data: IProductGridKey) => {
  const {
    params: { availability, deliveryWindowId, orderId },
  } = data;
  return [
    data.teamId,
    data.queryKey,
    data.params.productColorId,
    { availability, deliveryWindowId, orderId },
  ];
};
